import { render, staticRenderFns } from "./notifications-panel-actions.vue?vue&type=template&id=a727726c&scoped=true"
import script from "./notifications-panel-actions.vue?vue&type=script&lang=js"
export * from "./notifications-panel-actions.vue?vue&type=script&lang=js"
import style0 from "./notifications-panel-actions.vue?vue&type=style&index=0&id=a727726c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a727726c",
  null
  
)

export default component.exports